import { TextDecorationType } from '@kubit/web-ui-components/text/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const containersCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    container: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'flex-start',
        justify_content: 'flex-start',
        position: 'relative',
        border_radius: FOUNDATIONS.radius_comp_feedback_calloutalert_radiussize,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_comp_feedback_calloutalert_bordersize,
        border_color: FOUNDATIONS.color_comp_feedback_calloutalert_iconillustrationimage_border,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
        gap: FOUNDATIONS.spacing_150,
        background_color: FOUNDATIONS.color_neutral_bg_550,
    },
    contentSectionContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        width: '100%',
        text_decoration: TextDecorationType.NONE,
    },
    contentSectionWithoutDecorativeContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        margin_right: `calc(${FOUNDATIONS.size_300} + ${FOUNDATIONS.spacing_150})`,
        width: '100%',
    },
});
export const commonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
        font_weight: FONT_WEIGHT.font_weight_600,
        word_break: 'break-word',
    },
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
        word_break: 'break-word',
    },
    closeButtonContainer: {
        display: 'flex',
        justify_content: 'flex-end',
        order: '1',
    },
    closeButton: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
});
export const cardCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
    cardContainer: {
        ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS).container,
        background_color: FOUNDATIONS.color_comp_feedback_calloutalert_conversational_bg,
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
    },
    contentSectionContainer: {
        ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS).contentSectionContainer,
    },
    contentSectionWithoutDecorativeContainer: {
        ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS).contentSectionWithoutDecorativeContainer,
        margin_right: FOUNDATIONS.spacing_00,
    },
    closeButtonDecorativeContainer: {
        order: '1',
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_100,
    },
    closeButtonContainer: {
        ...commonStyles(FOUNDATIONS, FONT, SHADOWS).closeButtonContainer,
        order: '0',
    },
    descriptionContainer: {
        display: 'flex',
        flex: 1,
    },
    title: {},
});
export const mediumCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    ...cardCommonStyles(FOUNDATIONS, FONT, SHADOWS),
    illustration: {
        width: FOUNDATIONS.size_550,
        height: FOUNDATIONS.size_550,
    },
});
export const largeCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    ...cardCommonStyles(FOUNDATIONS, FONT, SHADOWS),
    description: {
        ...cardCommonStyles(FOUNDATIONS, FONT, SHADOWS).description,
        font_variant: TextVariantType.FONT_TITLE_50,
    },
    illustration: {
        width: FOUNDATIONS.size_650,
        height: FOUNDATIONS.size_650,
    },
});
//# sourceMappingURL=commonStyles.js.map